export const WHATSAPP_URL = 'https://api.whatsapp.com/send/?phone=553799841228&text=Ol%C3%A1%21+Venho+atrav%C3%A9s+do+site+e+gostaria+de+algumas+informa%C3%A7%C3%B5es.&type=phone_number&app_absent=0';
